<template>
    <div class="FeaturesTheApp">
        <section class="container-fluid pozadina" id="features">
    <div class="s-features">
      <div class="container py-5">
        <div class="row justify-content-center">
          <div class="col-12">
            <div class="box-1 my-3 ">
              <h2 class="text-center">Features The App</h2>
              <p class="lead text-center pb-4">Writers and stars of Veep have responded incredulously to the news an
                Australian
                politician
                required preinstalled stitches way email client, calendar, mapping program.</p>
            </div>
          </div>



          <div class="wrapper-tel col-8 col-lg-6 d-flex justify-content-center align-items-start">
            <!-- <img class=" img-fluid" src="./img/Group3.png" alt=""> -->
            <div id="slajd" class="carousel img-fluid" data-ride="carousel" data-interval="2000">
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <img class="img-fluid" src="../assets/img/11.png" alt="">
                </div>
                <div class="carousel-item">
                  <img class="img-fluid" src="../assets/img/12.png" alt="">
                </div>
                <div class="carousel-item">
                  <img class="img-fluid" src="../assets/img/13.png" alt="">
                </div>
                <div class="carousel-item">
                  <img class="img-fluid" src="../assets/img/14.png" alt="">
                </div>
                <div class="carousel-item">
                  <img class="img-fluid" src="../assets/img/15.png" alt="">
                </div>
              </div>
            </div>
          </div>


          <div class="col-12 col-lg-6">
            <div class="row">
              <div class="box-con d-flex flex-column flex-md-row align-items-center align-items-md-start">
                <div class="slika-poz d-flex align-items-center justify-content-center mt-5 mt-lg-2 mb-4">
                  <img class="ikonica" src="../assets/img/img1.png" alt="">
                </div>
                <div class="box-tekst">
                  <h5 class="text-center text-md-left pt-md-5 pt-lg-0">CREATIVE DESIGN</h5>
                  <p class="text-center text-md-left">Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Doloremque porro asperiores
                    facilis
                    hic libero eum rerum beatae eligendi error velit.</p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="box-con d-flex flex-column flex-md-row align-items-center align-items-md-start">
                <div class="slika-poz d-flex align-items-center justify-content-center mt-2 mb-4">
                  <img class="ikonica" src="../assets/img/img2.png" alt="">
                </div>
                <div class="box-tekst">
                  <h5 class="text-center text-md-left">UNLIMITED FEATURES</h5>
                  <p class="text-center text-md-left">Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Doloremque porro asperiores
                    facilis
                    hic libero eum rerum beatae eligendi error velit.</p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="box-con d-flex flex-column flex-md-row align-items-center align-items-md-start">
                <div class="slika-poz d-flex align-items-center justify-content-center mt-2 mb-4"> 
                  <img class="ikonica" src="../assets/img/img3.png" alt="">
                </div>
                <div class="box-tekst">
                  <h5 class="text-center text-md-left">USER FRIENDLY</h5>
                  <p class="text-center text-md-left">Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Doloremque porro asperiores
                    facilis
                    hic libero eum rerum beatae eligendi error velit.</p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="box-con d-flex flex-column flex-md-row align-items-center align-items-md-start">
                <div class="slika-poz d-flex align-items-center justify-content-center mt-2 mb-4">
                  <img class="ikonica" src="../assets/img/img4.png" alt="">
                </div>
                <div class="box-tekst">
                  <h5 class="text-center text-md-left">CLEAN CODES</h5>
                  <p class="text-center text-md-left">Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Doloremque porro asperiores
                    facilis
                    hic libero eum rerum beatae eligendi error velit.</p>
                </div>
              </div>
            </div>
          </div>


        </div>



      </div>
    </div>
  </section>
    </div>
</template>

<script>
export default {
  name: 'FeaturesTheApp',
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

@import '../style.css';

.pozadina{
    background-image: url('../assets/img/pozadina.png');
    background-repeat: no-repeat;
    background-size: cover;
    color: white;
}

.s-features {
    padding-bottom: 20%;
}
.box-con{
    padding: 0 0 30px 0;
    /* border: 1px solid yellow; */
}

.slika-poz{
    background-color: white;
    height: 77px;
    width: 77px;
    border-radius: 50%;
}
.slika-poz img{
    width: 44px;
    height: 44px;
}

.ikonica{
    padding: 5%;
}

.box-tekst{
    padding-left: 30px;
    width: 80%;
}

.pozadina-slajder, .pozadina-telefon{
    background-image: url("../assets/img/blank.png");
    background-repeat: no-repeat;
}

.slajder-pozicija{
    position: absolute;
    top: 99px;
    left: 52px;
}


@media screen and (max-width:769px) {

 img{
     margin: 2%;
 }

 .wrapper-tel{
     width: 80%;
 }
}


</style>
